<template>
<!-- 查看和修改个人信息弹窗 -->
  <div class="switch-project-wrapper c-pl-SwitchProject">
    <el-dialog
      title="个人信息"
      :visible.sync="centerDialogVisible"
      :before-close="handleClose"
      width="62.5rem"
      center
    >
  <div id="my-uesr-info">
    <div class="info-main">
       <div class="header">
       </div>
       <div class="body">
         <el-form ref="form" :rules="rules" label-position="right" :model="form" label-width="100px">
          <div class="form-main">
             <div class="title">
               <div>个人信息</div>
             </div>
             <div class="form-body">
                <el-form-item label="姓名：" prop="nickname">
                  <el-input v-model="form.nickname" placeholder="请输入姓名" :disabled="isEdit"></el-input>
                </el-form-item>
                <el-form-item label="性别：" prop="sex">
                  <el-radio-group v-model="form.sex" :disabled="isEdit">
                    <el-radio label="1">男</el-radio>
                    <el-radio label="2">女</el-radio>
                  </el-radio-group>
                </el-form-item>

                <el-form-item label="学历：">
                  <el-select v-model="form.edu" placeholder="请选择学历" style="width:100%" :disabled="isEdit">
                    <el-option
                      v-for="item in eduList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="专业：">
                  <el-input v-model="form.major" placeholder="请输入专业名称" :disabled="isEdit"></el-input>
                </el-form-item>
                <el-form-item label="毕业时间：">
                  <el-date-picker
                    style="width:100%"
                    :disabled="isEdit"
                    v-model="form.eTime"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="选择毕业日期">
                  </el-date-picker>
                </el-form-item>
             </div>
          </div>
          <div class="form-main">
             <div class="title">
               <!-- <div>职业信息</div> -->
             </div>
             <div class="form-body">
                <el-form-item label="所在地区：" style="display: inline-block;width: 58%;">
                  <el-select v-model="form.provinceId" @change="GetCity()" placeholder="请选择省份" :disabled="isEdit">
                    <el-option
                      v-for="item in provinceList"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label-width="0" style="display: inline-block;width: 32%;margin-left:10%">
                  <el-select v-model="form.cityId" placeholder="请选择市区" :disabled="isEdit">
                    <el-option
                      v-for="item in cityList"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="所在行业：">
                  <el-select v-model="form.industry" style="width:100%" placeholder="请选择所在行业" :disabled="isEdit">
                    <el-option
                      v-for="item in tradeList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="职位：">
                  <el-input v-model="form.position" placeholder="请输入职位名称" :disabled="isEdit"></el-input>
                </el-form-item>
                <el-form-item label="从业年限：">
                  <el-select v-model="form.jobYear" style="width:100%" placeholder="请选择从业年限" :disabled="isEdit">
                    <el-option
                      v-for="item in jobsList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
             </div>
          </div>
          <div class="form-main">
             <div class="title">
               <!-- <div>邮箱信息</div> -->
             </div>
             <div class="form-body">
                <el-form-item label="常用邮箱：" prop="email">
                  <el-input v-model="form.email" placeholder="请输入常用邮箱" :disabled="isEdit"></el-input>
                </el-form-item>
             </div>
          </div>
          <!-- <div class="submit-btn">
            <el-form-item>
              <el-button type="primary" style="background-color:#36ABFF"  v-if="!isEdit" @click="onSubProject('form')">保存设置</el-button>
              <el-button type="primary" v-if="isEdit" @click="isEdit = false">选择修改</el-button>
            </el-form-item>
          </div> -->
        </el-form>
       </div>
    </div>
  </div>
    </el-dialog>
  </div>
</template>
<script>
import * as INFO_API from '@/api/ChannelCustomerAPI'
export default {
  name: 'SwitchCustomer',
  props: ['show'],
  data () {
    return {
      centerDialogVisible: false,
      isSelect: false,
      // 上传用的file
      file: '',
      // 是否显示头像上传
      dialogVisible: false,

      // 用户头像
      imageUrl: '',
      avatarUrl: localStorage.getItem('user_avatar') || '',
      // 控制弹窗是显示按钮
      isBtnSubmit: 2,
      // 是否可以编辑
      isEdit: true,
      // 确认选中
      form: {
        nickname: '',
        sex: '',
        // 意向
        intent: '',
        // 学历
        edu: '',
        // 专业
        major: '',
        // 意向考试
        intentionCourseId: '',
        // 毕业时间
        eTime: '',
        // 市区
        cityId: '',
        // 省
        provinceId: '',
        // 行业
        industry: '',
        // 职位
        position: '',
        // 工作年限
        jobYear: '',
        email: ''
      },
      intentionCourseId: '',
      intentionCourseName: '',
      intentionCourseLabelList: [],
      labelList: [],
      jobsList: [{
        value: '1年以内',
        label: '1年以内'
      }, {
        value: '1-3年',
        label: '1-3年'
      }, {
        value: '3-5年',
        label: '3-5年'
      }, {
        value: '5-10年',
        label: '5-10年'
      }, {
        value: '10年以上',
        label: '10年以上'
      }
      ],
      tradeList: [{
        value: '未毕业',
        label: '未毕业'
      }, {
        value: '互联网',
        label: '互联网'
      }, {
        value: 'IT',
        label: 'IT'
      }, {
        value: '制造业',
        label: '制造业'
      }, {
        value: '金融',
        label: '金融'
      }, {
        value: '教育',
        label: '教育'
      }, {
        value: '医药医疗',
        label: '医药医疗'
      }, {
        value: '建筑房地产',
        label: '建筑房地产'
      }, {
        value: '传媒',
        label: '传媒'
      }, {
        value: '政府机关',
        label: '政府机关'
      }
      ],
      provinceList: [],
      cityList: [],
      eduList: [{
        value: '初中',
        label: '初中'
      }, {
        value: '高中',
        label: '高中'
      }, {
        value: '中专',
        label: '中专'
      }, {
        value: '大专',
        label: '大专'
      }, {
        value: '本科',
        label: '本科'
      }, {
        value: '研究生',
        label: '研究生'
      }, {
        value: '硕士',
        label: '硕士'
      }, {
        value: '博士及以上',
        label: '博士及以上'
      }
      ],
      rules: {
        nickname: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        age: [
          { required: true, message: '请选择性别', trigger: ['blur', 'change'] }
        ],
        email: [
          { required: true, message: '请输入常用邮箱', trigger: 'blur' }
        ]
      } 
    }
  },
  mounted () {
          // 获取省份的接口
    this.GetProvinceList()
    // 初始化数据的接口
  //  this.GetUserDetail()
  },
  watch: {
    show: function (val) {
      this.centerDialogVisible = val
    },
    centerDialogVisible () {
      console.log(this.centerDialogVisible)
    }
  },
  methods: {
    handleClose(done) {
      this.$emit('onChangeProject', { isSelect: true })
      this.$emit('onSubProject', false)
      done()
    },

    // 获取个人信息
    GetUserDetail () {
      INFO_API.GetUserDetail().then(res => {
        if (res && Number(res.code) === 0) {
          for (let key in this.form) {
            if (key === 'sex' || key === 'provinceId' || key === 'cityId') {
              this.form[key] = (res.data[key] === 0 ? '' : String(res.data[key]))
            } else {
              this.form[key] = (res.data[key] === 0 ? '' : res.data[key])
            }
          }
          this.$addStorageEvent(0, 'nickname', res.data.nickname)
          this.intentionCourseName = res.data.intentionCourseName
          this.intentionCourseLabelList = res.data.intentionCourseLabelList
          this.GetCityList(this.form.provinceId)
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取省份
    GetProvinceList () {
      INFO_API.GetProvinceList().then(res => {
        if (res && Number(res.code) === 0) {
          this.provinceList = res.data
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      }).catch(err => {
        console.log(err)
      })
    },
    // 获取市区
    GetCityList (code) {
      console.log(code)
      if (!code) {
        return
      }
      let data = {
        provinceCode: code
      }
      INFO_API.GetCityList(data).then(res => {
        if (res && Number(res.code) === 0) {
          this.cityList = res.data
        } else {
          this.$message({
            type: 'error',
            message: res.msg
          })
        }
      }).catch(err => {
        console.log(err)
      })
    },


    // 保存个人资料
    onSubProject (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          INFO_API.SetUserDetail(this.form).then(res => {
            if (res && Number(res.code) === 0) {
              this.$message({
                type: 'success',
                message: '修改成功'
              })
              this.GetUserDetail()
              this.isEdit = true
            } else {
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
         this.isSelect = true
         this.$emit('onChangeProject', { isSelect: false })
         this.$emit('onSubProject', )
          }).catch(err => {
            console.log(err)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 点击省份获取市区
    GetCity () {
      this.cityList = []
      this.form.cityId = ''
      this.GetCityList(this.form.provinceId)
    }

  }
}
</script>
